import { ROUTE_PATHS } from "@bcc/lib/constants";
import { TOUR_IDS } from "../tour-ids";
import type { FeatureTour } from "../tour.types";
import { tourTargetSelector } from "../tour.utils";

export const contactUsTour: FeatureTour = {
  id: "contact-us",
  titleKey: "tour.features.contact-us.title",
  order: 7,
  steps: [
    {
      id: "contact-us.overview",
      route: ROUTE_PATHS.CONTACT_US,
      target: tourTargetSelector(TOUR_IDS.contactUs.page),
      titleKey: "tour.steps.contact-us.overview.title",
      bodyKey: "tour.steps.contact-us.overview.body",
      placement: "bottom",
    },
  ],
};
